// API Configuration
export const API_URL = process.env.REACT_APP_API_URL;
// "https://backend-empty-fire-4935.fly.dev" or "http://localhost:8000"

// Other configuration constants can be added here as needed
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

// Google Analytics
export const GA_TRACKING_ID = "G-Q1B8S91BLQ";
